import LocalizationStore from '../Stores/LocalizationStore'
import { AjvError } from 'react-jsonschema-form'

const ls = LocalizationStore.getInstance()

export function getCommentFormSchema(): any {
    return {
        'type': 'object',
        'required': [
            'comment'
        ],
        'properties': {
            'comment': {
                'type': 'string'
            }
        }
    }
}

export const UICommentFormSchema = {
    'comment': {
        'ui:widget': 'textarea'
    }
}

export function transformErrors(errors: Array<AjvError>) {
    return errors.map((error: AjvError) => {
        if (error['name'] === 'required') {
            error['message'] = ls.t('is a required property')
        }
        return error
    })
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Model/CommentForm.ts